import { createDCShipment } from "api/shipment";
import { Button } from "components/Form";
import React, { useState } from "react";
import * as XLSX from "xlsx";
import { useLayoutDispatch, popupNotification } from "context/LayoutContext";

const DCImportButton = () => {
  const [labelLoading, setLabelLoading] = useState(false);
  const layoutDispatch = useLayoutDispatch();

  // Excel dosyasını okuyup istediğimiz formata çeviren fonksiyon
  const parseExcelFile = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (evt) => {
        const data = evt.target.result;
        const workbook = XLSX.read(data, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        let jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: "" });

        const result = {};
        const lines = [];
        const shipmentData = {};

        // generate shipment and order #
        jsonData.forEach((value, index) => {
          const now = new Date();
          const pad = (n) => n.toString().padStart(2, "0");
          const sn =
            "obt_dcshipment_" +
            pad(now.getHours()) +
            "_" +
            pad(now.getMinutes()) +
            "_" +
            pad(now.getSeconds());
          value["Shipment Number"] = sn;
          value["Order Number"] = sn;
          value["Line Number"] = index + 2;
        });

        jsonData.forEach((row) => {
          const marketplace = row["Marketplace"];
          if (!result["customer"]) {
            result["customer"] = marketplace;
            shipmentData["customer"] = marketplace;
            shipmentData["po_number"] = row["PO Number"];
            shipmentData["shipment_number"] = row["Shipment Number"];
            shipmentData["order_number"] = row["Order Number"];
            shipmentData["customer_name"] = row["Customer Name"];
            shipmentData["phone"] = row["Phone"];
            shipmentData["line_1"] = row["Line 1"];
            shipmentData["line_2"] = row["Line 2"];
            shipmentData["city"] = row["City"];
            shipmentData["state"] = row["State"];
            shipmentData["zip_code"] = row["Zip Code"];
            shipmentData["country"] = row["Country"];
            shipmentData["ship_via"] =
              row["Ship Via"] || row["Ship Method"] || "LTL";
          }
          if (row["Customer Part Number"]) {
            result[row["Customer Part Number"]] = row["SKU"];
          }
          lines.push({
            sku: row["SKU"],
            quantity: row["Quantity"],
            customer_part_number: row["Customer Part Number"],
            customer_order_number: row["Customer Order Number"],
            po_number: row["PO Number"],
          });
        });
        resolve({ result, lines, shipmentData });
      };

      reader.onerror = (err) => reject(err);

      reader.readAsBinaryString(file);
    });
  };

  const handleDCFileChange = async (e) => {
    setLabelLoading(true);
    const files = Array.from(e.target.files);
    const supportedTypes = {
      "application/pdf": "pdf",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        "excel",
      "application/vnd.ms-excel": "excel",
    };

    const readFileAsBase64 = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result.split(",")[1]); // only base64 part
        reader.onerror = reject;
        reader.readAsDataURL(file); // base64 with prefix
      });
    };

    const results = [];
    let excelData = {};

    for (const file of files) {
      const type = supportedTypes[file.type];
      if (!type) {
        console.warn(`${file.name} unsupported file type: ${file.type}`);
        continue;
      }

      if (type === "excel") {
        // Excel'i parse edip data olarak ekliyoruz
        const parsedData = await parseExcelFile(file);
        excelData = parsedData;
      }

      const base64 = await readFileAsBase64(file);

      results.push({
        type,
        value: base64,
        name: file.name,
      });
    }

    createDCShipment({
      body: { files: results, excelData },
      responseSetter: (res) => {
        popupNotification({
          dispatch: layoutDispatch,
          message: res.message,
          status: !res.success ? "error" : "success",
        });
        setLabelLoading(false);
      },
    });
  };

  return (
    <span title="Upload Excel  + PDF labels together">
      <Button
        variant="contained"
        disabled={labelLoading}
        color="primary-light"
        component="label"
        style={{ width: "150px" }}
      >
        {labelLoading ? "Uploading..." : "DC Shipments"}
        <input
          id="files"
          hidden
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/pdf"
          type="file"
          multiple
          onChange={handleDCFileChange}
        />
      </Button>
    </span>
  );
};

export default DCImportButton;
